import { render, staticRenderFns } from "./SalesHistory.vue?vue&type=template&id=469983da&scoped=true&"
import script from "./SalesHistory.vue?vue&type=script&lang=js&"
export * from "./SalesHistory.vue?vue&type=script&lang=js&"
import style0 from "./SalesHistory.vue?vue&type=style&index=0&id=469983da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469983da",
  null
  
)

export default component.exports